//Returns an array of values from start to stop in nsteps equally spaced intervals.
export const linspace = function(start, stop, nsteps) {
  var delta = (stop-start)/(nsteps-1)
  var i;
  var out = []
  for (i = 0; i < nsteps; ++i) {
    out.push(i * delta);
  }
  return out;
}

export const normalize = function(cn) {
  let n = cn.length;
  let nrm = 0.0;
  var i;
  for (i = 0; i < n; ++i) {
    nrm += cn[i] * cn[i];
  }

  let out = [];
  nrm = (nrm < 1e-10) ? 0.0 : 1.0 / Math.sqrt(nrm);
  for (i = 0; i < n; ++i) {
    out.push(cn[i] * nrm);
  }
  return out
}
